/**
 * ![yellow 50](https://mui.com/static/colors-preview/yellow-50-24x24.png) ![yellow 100](https://mui.com/static/colors-preview/yellow-100-24x24.png) ![yellow 200](https://mui.com/static/colors-preview/yellow-200-24x24.png) ![yellow 300](https://mui.com/static/colors-preview/yellow-300-24x24.png) ![yellow 400](https://mui.com/static/colors-preview/yellow-400-24x24.png) ![yellow 500](https://mui.com/static/colors-preview/yellow-500-24x24.png) ![yellow 600](https://mui.com/static/colors-preview/yellow-600-24x24.png) ![yellow 700](https://mui.com/static/colors-preview/yellow-700-24x24.png) ![yellow 800](https://mui.com/static/colors-preview/yellow-800-24x24.png) ![yellow 900](https://mui.com/static/colors-preview/yellow-900-24x24.png) ![yellow A100](https://mui.com/static/colors-preview/yellow-A100-24x24.png) ![yellow A200](https://mui.com/static/colors-preview/yellow-A200-24x24.png) ![yellow A400](https://mui.com/static/colors-preview/yellow-A400-24x24.png) ![yellow A700](https://mui.com/static/colors-preview/yellow-A700-24x24.png)
 */
const yellow = {
  /**
   * Preview: ![yellow 50](https://mui.com/static/colors-preview/yellow-50-24x24.png)
   */
  50: '#fffde7',
  /**
   * Preview: ![yellow 100](https://mui.com/static/colors-preview/yellow-100-24x24.png)
   */
  100: '#fff9c4',
  /**
   * Preview: ![yellow 200](https://mui.com/static/colors-preview/yellow-200-24x24.png)
   */
  200: '#fff59d',
  /**
   * Preview: ![yellow 300](https://mui.com/static/colors-preview/yellow-300-24x24.png)
   */
  300: '#fff176',
  /**
   * Preview: ![yellow 400](https://mui.com/static/colors-preview/yellow-400-24x24.png)
   */
  400: '#ffee58',
  /**
   * Preview: ![yellow 500](https://mui.com/static/colors-preview/yellow-500-24x24.png)
   */
  500: '#ffeb3b',
  /**
   * Preview: ![yellow 600](https://mui.com/static/colors-preview/yellow-600-24x24.png)
   */
  600: '#fdd835',
  /**
   * Preview: ![yellow 700](https://mui.com/static/colors-preview/yellow-700-24x24.png)
   */
  700: '#fbc02d',
  /**
   * Preview: ![yellow 800](https://mui.com/static/colors-preview/yellow-800-24x24.png)
   */
  800: '#f9a825',
  /**
   * Preview: ![yellow 900](https://mui.com/static/colors-preview/yellow-900-24x24.png)
   */
  900: '#f57f17',
  /**
   * Preview: ![yellow A100](https://mui.com/static/colors-preview/yellow-A100-24x24.png)
   */
  A100: '#ffff8d',
  /**
   * Preview: ![yellow A200](https://mui.com/static/colors-preview/yellow-A200-24x24.png)
   */
  A200: '#ffff00',
  /**
   * Preview: ![yellow A400](https://mui.com/static/colors-preview/yellow-A400-24x24.png)
   */
  A400: '#ffea00',
  /**
   * Preview: ![yellow A700](https://mui.com/static/colors-preview/yellow-A700-24x24.png)
   */
  A700: '#ffd600',
} as const;

export default yellow;
